import { render, staticRenderFns } from "./TestReportList.vue?vue&type=template&id=95727b18&"
import script from "./TestReportList.vue?vue&type=script&lang=ts&"
export * from "./TestReportList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports